import { useSelector } from 'react-redux';
import styled from 'styled-components';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import { calculatedPriceSelector } from '../../selectors/PricingSelectors';
import { currentSkuIdForProductSelector } from '../../selectors/ProductsSelectors';
import PriceDisplay from '../common/pricing/PriceDisplay';
import { useQueryParamTerm } from '../../utils/urls/appQueryParamUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const Subtext = styled.span.withConfig({
  displayName: "FeatureTablePriceDisplay__Subtext",
  componentId: "jctdt1-0"
})(["display:inline-block;font-weight:normal;margin-top:4px;font-size:0.875rem;"]);
const FeatureTablePriceDisplay = ({
  apiName
}) => {
  const currencyCode = useSelector(activeCurrencySelector);
  const skuId = useSelector(state => {
    return currentSkuIdForProductSelector(state, {
      apiName
    });
  });
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const pricingInfo = useSelector(state => {
    return calculatedPriceSelector(state, {
      productConfigurations: [createProductConfig({
        skuId
      })],
      queryParamTerm
    });
  });
  const price = pricingInfo && pricingInfo.monthly && pricingInfo.monthly.calculatedPrice;
  const seleniumId = apiName || 'loading';
  return /*#__PURE__*/_jsx(Subtext, {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "featureTable.pricing_jsx",
      elements: {
        PriceDisplay
      },
      options: {
        currencyCode,
        seleniumId,
        price
      }
    })
  });
};
export default FeatureTablePriceDisplay;